import src from "IMAGE";
export default { src, width: 2500, height: 303, blurWidth: 0, blurHeight: 0};
